import MojitoCore from 'mojito/core';
import PrebuiltAccaClassic from './classic/index.js';
import PrebuiltAccaAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

export default UIViewFamily('PrebuiltAcca', {
    classic: PrebuiltAccaClassic,
    avantgarde: PrebuiltAccaAvantgarde,
});
